import React from 'react'
import {Fragment} from 'react'
import classnames from 'classnames'

import {THeaderBlockItem} from '../../types'
import {LinkListItem} from './LinkListItem'

import styles from './styles.module.css'

type TLinkListItemProps = {
  item: THeaderBlockItem
  className?: string
  index?: number
  withDivider?: boolean
}

export function ListLink({item, index, withDivider, className}: TLinkListItemProps) {
  return (
    <Fragment key={index?.toString()}>
      {withDivider && index !== 0 && (
        <hr className={classnames(styles.linkListItemHr, {[styles.mobile]: item.mobileOnly})} />
      )}
      <LinkListItem item={item} className={className} />
    </Fragment>
  )
}
